module.exports = __webpack_public_path__ + "media/images/redesign-images/sorority-new/design-tile-images/design-tile-05-f232c10a7a91ebb4faf683b3a08ca6cf.jpg";